import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-98">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-pink-light text-slate text-sm font-bold mb-6" data-id="element-99">
              <Zap size={16} className="text-teal" data-id="element-100" />
              <span data-id="element-101">Resultados este fin de semana</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate leading-[1.1] mb-6" data-id="element-102">
              Dile Adiós a los Pañales en Solo 3 Días{' '}
              <br className="hidden md:block" data-id="element-103" />
              <span className="text-teal italic font-light" data-id="element-104">
                (Sin Gritos, Sin Estrés y Sin Lágrimas)
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl text-slate-light font-medium mb-8 leading-relaxed" data-id="element-105">
              El método de "Conexión Sensorial" diseñado para madres agotadas
              que necesitan resultados reales este mismo fin de semana.
            </h2>

            <div className="space-y-4 mb-10 text-left bg-white/60 p-6 rounded-2xl border border-teal/10" data-id="element-106">
              <p className="text-slate-light leading-relaxed" data-id="element-107">
                <span className="font-bold text-slate" data-id="element-108">
                  Sé lo que es despertarse a las 3 AM
                </span>{' '}
                para cambiar una sábana mojada, o sentir ese nudo en el estómago
                cuando tu hijo tiene un accidente en medio del supermercado.
                Peor aún, sentir la presión del jardín de infancia exigiéndote
                que tu hijo "ya debería estar seco".
              </p>
              <p className="text-slate-light leading-relaxed font-medium" data-id="element-109">
                No estás fallando como mamá. Simplemente estás usando métodos
                diseñados para una época que ya no existe.
              </p>
            </div>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-110">
              <Button data-id="element-111">¡QUIERO EMPEZAR EL PROTOCOLO AHORA!</Button>
              <div className="flex items-center gap-2 text-sm text-slate-light font-medium" data-id="element-112">
                <ShieldCheck size={16} className="text-teal" data-id="element-113" />
                <span data-id="element-114">
                  Compra segura. Acceso instantáneo por correo electrónico.
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-115">
            <div className="absolute inset-0 bg-teal/5 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-116"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2JJEnxNq6eehzBrz8hycMw/portada_ADIOS_PANAL.png" alt="Pañal Adiós - Protocolo de 3 Días" className="w-full h-auto object-contain drop-shadow-2xl rounded-2xl" data-id="element-117" />
          </motion.div>
        </div>
      </div>
    </section>;
}